import * as api from "../Api";

export const getAllAdviceData = () => async (dispatch) => {
  try {
    const { data } = await api.getAllAdvice();
    dispatch({ type: "GET_ALL_ADVICE_DATA", payload: data });
  } catch (error) {}
};
